

const defaultProps = {
  legacy: false,
  visualizerType: 'Live',
  playerId: '',
  mediaOriginId: '',
};

export default defaultProps;



// WEBPACK FOOTER //
// ./src/base-player/default-props.js